import { object, string, number } from 'yup';
export const Fields = [
  {
    name: 'password',
    placeholder: 'Enter OTP',
    label: 'OTP',
    helper: true,
    maxLength: 6,
  },
];
export const validationSchema = object({
  password: string()
    .required('Required')
    .matches(/^[0-9]+$/, 'OTP has to be number only'),
});
export const initialValues = {
  password: '',
};
